import { DatesHelpers } from "@core/helpers";
import { BillingSessionAmountModel } from "./billing-session-amount.model";

export const IBillingSession = Object.freeze({
  id: "billing_session_id",
  comment: "comment",
  type: "type",
  invoiceDate: "invoice_date",
  payoutDate: "payout_date",
  additionalTotal: "total_additional",
  customerTotal: "total_line",
  generalTotal: "total",
});

export class BillingSessionModel {
  constructor(data = {}) {
    this[IBillingSession.id] = data[IBillingSession.id];
    this[IBillingSession.comment] = data[IBillingSession.comment];
    this[IBillingSession.type] = data[IBillingSession.type];
    this[IBillingSession.generalTotal] = data[IBillingSession.generalTotal];
    this[IBillingSession.customerTotal] = data[IBillingSession.customerTotal];
    this[IBillingSession.additionalTotal] = data[IBillingSession.additionalTotal];
    this[IBillingSession.invoiceDate] = data[IBillingSession.invoiceDate];
    this[IBillingSession.payoutDate] = data[IBillingSession.payoutDate];
  }

  getId() {
    return this[IBillingSession.id];
  }

  getComment() {
    return this[IBillingSession.comment] || "";
  }

  getBillingDate() {
    return DatesHelpers.getFormattedDate(this[IBillingSession.invoiceDate]);
  }

  getPayoutDate() {
    return DatesHelpers.getFormattedDate(this[IBillingSession.payoutDate]);
  }

  getType() {
    return this[IBillingSession.type];
  }

  getGeneralTotal() {
    return new BillingSessionAmountModel(this[IBillingSession.generalTotal]);
  }

  getCustomerTotal() {
    return new BillingSessionAmountModel(this[IBillingSession.customerTotal]);
  }

  getAdditionalTotal() {
    return new BillingSessionAmountModel(this[IBillingSession.additionalTotal]);
  }
}
